import React, { Component } from 'react';
import { Modal, Button, Input, message, Upload, Radio, Select, Tooltip } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';


const RadioGroup = Radio.Group;
const Option = Select.Option;

class UploadFileModal extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        fileList: [],
        catalogId: '',
        catalogType: '',
        pathName: '',
        involveSites: [],
    }

    show = (catalogId, catalogType, pathName) => {
        const { params } = this.state;
        if ((catalogType == 'COLLABORATIVE_VISIT' || catalogType == 'INV_MAJOR_EVENTS') && sessionStorage.siteId > 0) {
            params.influenceLevel = 'SITE_LEVEL';
        }
        this.setState({
            catalogId,
            catalogType,
            visible: true,
            pathName,
            params,
        },() => {
            this.queryInvolveSite();
        });
    }

    queryInvolveSite = () => {
        const { catalogType } = this.state;
        let url = '';
        switch (catalogType) {
            case 'COLLABORATIVE_VISIT':  //协同访视
            case 'INV_MAJOR_EVENTS': //重大事件
                url = API_URL.invFolder.involveSites;
                break;
            case 'CRC_PROCOTOL':   
                url = API_URL.invFolder.procotalInvolveSites;
                break;
            case 'CRC_LETTER': 
                url = API_URL.invFolder.letterInvolveSites;
                break;
            case 'INV_MEMBER_VITAE': 
                url = API_URL.invFolder.memberVitaeInvolveSites;
                break;
        };
        if (!url) {
            return
        }
        const options = {
            method: 'POST',
            url,
            data: {
                invId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { involveSites } = res;
                this.setState({ involveSites });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            params: {},
            fileList: [],
            involveSites: [],
            visible: false,
            loading: false,
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    beforeUpload = (file, fileList) => {
        this.setState({
            fileList:[
                ...this.state.fileList,
                ...fileList,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({fileList: newFileList});
    }

    submit = () => {
        const { params, fileList, catalogId, catalogType, involveSites } = this.state;
        const { 
            crcDownloadFlag, 
            version,
            influenceLevel,
            isHandle,
            involveSiteId: involveSiteIdData,
        } = params;
        const { siteId } = sessionStorage;
        //校验必填
        if (fileList.length === 0) {
            return message.warning('请选择需要上传的文件')
        }
        switch (catalogType) {
            case 'SCHEME_GUIDE':
                if (!crcDownloadFlag && siteId == 0) {
                    return message.warning('请选择是否允许CRC下载')
                }
                if (!version) {
                    return message.warning(`请输入版本号`)
                }
                break;
            case 'FEASIBILITY_STUDY_REPORT':
            case 'INV_TRAIN_MATERIAL':
                if (!crcDownloadFlag && siteId == 0) {
                    return message.warning('请选择是否允许CRC下载')
                }
                break;
            case 'INV_MANAGEMENT_PLAN':
            case 'INV_MEETING_MINUTES':
            case 'INV_PROGRESS_REPORT':
            case 'INV_EXECUTION_REPORT':
            case 'FINANCIAL_DOCUMENTS':
            case 'OTHER':
                if (!version) {
                    return message.warning(`请输入版本号`)
                }
                break;
            case 'COLLABORATIVE_VISIT':
            case 'INV_MAJOR_EVENTS':
                if (!influenceLevel) {
                    return message.warning(`请选择涉及层面`)
                }
                if (influenceLevel =='SITE_LEVEL' && !involveSiteIdData.length) {
                    return message.warning(`请选择涉及中心`)
                }
                if (!isHandle) {
                    return message.warning(`请选择事件处理结束与否`)
                }
                break;
            case 'CRC_PROCOTOL':
            case 'CRC_LETTER':
            case 'INV_MEMBER_VITAE':
                if (!involveSiteIdData) {
                    return message.warning(`请选择涉及中心`)
                }
                if (!crcDownloadFlag && siteId == 0) {
                    return message.warning('请选择是否允许CRC下载')
                }
                break;
        }

        // 涉及中心不同情况下的取值
        let involveSiteId = '';
        let involveSiteName = '';
        switch (catalogType) {
            case 'COLLABORATIVE_VISIT':
            case 'INV_MAJOR_EVENTS':
                involveSiteId = (involveSiteIdData || []).join(';');
                const arr = [];
                involveSites.map(site => {
                    (involveSiteIdData || []).map(id => {
                        if (site.investigationSiteId == id) {
                            arr.push(site.investigationSiteName);
                        }
                    });
                });
                involveSiteName = arr.join(';');
                break;
            case 'CRC_PROCOTOL':
            case 'CRC_LETTER':
            case 'INV_MEMBER_VITAE':
                involveSiteId = involveSiteIdData;
                involveSiteName= involveSites.filter(site => site.investigationSiteId == involveSiteIdData)[0].investigationSiteName;
                break;
        }

        const fromData = new FormData();
        fileList.map((file, index) => {
            fromData.append(`files[${index}]`, file)
        });
        
        fromData.append('invId', sessionStorage.invId);
        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curRoleCode', sessionStorage.curRole);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
        fromData.append('catalogId', catalogId);
        if (crcDownloadFlag)fromData.append('crcDownloadFlag', crcDownloadFlag);
        if (version)fromData.append('version', version);
        if (influenceLevel)fromData.append('influenceLevel', influenceLevel);
        if (isHandle)fromData.append('isHandle', isHandle);
        if (involveSiteId)fromData.append('involveSiteId', involveSiteId);
        if (involveSiteName)fromData.append('involveSiteName', involveSiteName);
        this.setState({ loading: true });
        message.success('正在上传中!');
        fetch(API_URL.invFolder.uploadInvFile,{
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            if (data.error) {
                message.error(data.error);
                this.setState({ loading: false });
            } else {
                
                message.success(data.success);
                this.hide();
                this.props.queryTableData();
            }
        }).catch(err => {
            message.error(err);
        });
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    render() {
        const { visible, params, catalogType, fileList, pathName, involveSites, loading } = this.state;
        const { 
            crcDownloadFlag, 
            version,
            influenceLevel,
            isHandle,
            involveSiteId,
        } = params;
        const { siteId } = sessionStorage;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const involveSitesOption = involveSites.map(el => <Option value={el.investigationSiteId}>
                <Tooltip placement="right" title={`${el.investigationSiteName}（${el.investigationSiteCode}）`}>
                    {`${el.investigationSiteName}${el.investigationSiteId == -1 ? '' : `（${el.investigationSiteCode}）`}`}
                </Tooltip>
            </Option>);
        return (
            <Modal
                title={'上传文件'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="500px"
            >
                <div className="modal-content" style={{ padding: '20px 30px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div style={{ marginLeft: 40 }}>{pathName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{width: '40%'}}>{asterisk}上传附件：</div>
                                <div className="item-right" style={{width: '60%'}}>
                                    <Upload
                                        data={{
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        fileList={fileList}
                                        multiple={true}
                                        beforeUpload={this.beforeUpload}
                                        onRemove={this.handleRemove}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                </div>
                            </li>
                            {
                                this.booleanEquals(catalogType, [
                                    'CRC_PROCOTOL',
                                    'CRC_LETTER',
                                    'INV_MEMBER_VITAE',
                                ]) && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}涉及研究中心：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <Select
                                                placeholder='请选择'
                                                showSearch={this.booleanEquals(catalogType, ['CRC_PROCOTOL', 'CRC_LETTER'])}
                                                filterOption={(input, option) => option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                style={{ width: 160 }}
                                                allowClear
                                                value={involveSiteId}
                                                onChange={value => this.handleChange(value, 'involveSiteId')}
                                            >
                                                {involveSitesOption}
                                            </Select>
                                        </div>
                                    </li>
                            }
                            {
                                (this.booleanEquals(catalogType, [
                                    'SCHEME_GUIDE',
                                    'FEASIBILITY_STUDY_REPORT',
                                    'INV_TRAIN_MATERIAL',
                                    'CRC_PROCOTOL',
                                    'CRC_LETTER',
                                    'INV_MEMBER_VITAE',
                                ]) && siteId == 0) && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}是否允许CRC下载：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <RadioGroup 
                                                value={crcDownloadFlag}
                                                onChange={e => this.handleChange(e.target.value, 'crcDownloadFlag')} 
                                            >
                                                <Radio value='YES' style={{ marginRight: 50 }}>是</Radio>
                                                <Radio value='NO'>否</Radio>
                                            </RadioGroup>
                                        </div>
                                    </li>
                            }
                            {
                                this.booleanEquals(catalogType, [
                                    'SCHEME_GUIDE',
                                    'INV_MANAGEMENT_PLAN',
                                    'INV_MEETING_MINUTES',
                                    'INV_PROGRESS_REPORT',
                                    'INV_EXECUTION_REPORT',
                                    'FINANCIAL_DOCUMENTS',
                                    'OTHER',
                                ]) && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}版本号：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <Input 
                                                placeholder='请输入'
                                                style={{ width: 160 }}
                                                value={version}
                                                onChange={e => this.handleChange(e.target.value, 'version')}
                                            />
                                        </div>
                                    </li>
                            }
                            {
                                this.booleanEquals(catalogType, [
                                    'COLLABORATIVE_VISIT',
                                    'INV_MAJOR_EVENTS',
                                ]) && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}涉及层面：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <RadioGroup 
                                                value={influenceLevel}
                                                onChange={e => this.handleChange(e.target.value, 'influenceLevel')} 
                                            >
                                                <Radio disabled={siteId > 0} value='INVESTIGATION_LEVEL' style={{ marginRight: 50 }}>项目层面</Radio>
                                                <Radio value='SITE_LEVEL'>中心层面</Radio>
                                            </RadioGroup>
                                        </div>
                                    </li>
                            }
                            {
                                influenceLevel == 'SITE_LEVEL' && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}涉及研究中心：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <Select
                                                placeholder='请选择'
                                                mode='multiple'
                                                allowClear
                                                filterOption={(input, option) => option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                style={{ width: 160 }}
                                                value={involveSiteId}
                                                onChange={value => this.handleChange(value, 'involveSiteId')} 
                                            >
                                                {involveSitesOption}
                                            </Select>
                                        </div>
                                    </li>
                            }
                            {
                                this.booleanEquals(catalogType, [
                                    'COLLABORATIVE_VISIT',
                                    'INV_MAJOR_EVENTS',
                                ]) && <li className="modal-item">
                                        <div className="item-left" style={{width: '40%'}}>{asterisk}事件处理结束与否：</div>
                                        <div className="item-right" style={{width: '60%'}}>
                                            <RadioGroup 
                                                value={isHandle}
                                                onChange={e => this.handleChange(e.target.value, 'isHandle')} 
                                            >
                                                <Radio value='1' style={{ marginRight: 50 }}>是</Radio>
                                                <Radio value='0'>否</Radio>
                                            </RadioGroup>
                                        </div>
                                    </li>
                            }
                        </ul>
                    </div>
            </Modal>
        );
    }
}

export default UploadFileModal;


// WEBPACK FOOTER //
// ./src/components/fileManagement/projectFile/UploadFileModal.js